import Screen from "controllers/Screen";
import AbstractView from "abstracts/AbstractView";
import Matter from "matter-js";
import Main from "controllers/Main";
import MatterWrap from 'matter-wrap';
import Math_ from "utils/Math";
import Easing from "../../../../assets/src/js/app/utils/Easing";


export default class ContactHeader extends AbstractView {
	constructor($wrapper) {
		super();
		Matter.use(MatterWrap);
		this.$wrapper = $wrapper;
		this.debug = false;
		this.numRagdolls = 40;
		this.maxForce = 0;
		this.init();
	}

	initEl() {
		super.initEl();
		this.initMatter();
	}


	initMatter() {

		this.matterWidth = Screen.wW;
		this.matterHeight = Screen.wH;

		// create engine
		this.engine = Matter.Engine.create();
		this.world = this.engine.world;

		this.engine.gravity.y = 0.15;
		this.engine.gravity.x = 0.08;
		// this.engine.gravity.y = 0;
		// this.engine.gravity.x = 0;

		// create renderer
		this.render = Matter.Render.create({
			element: this.$wrapper[0],
			engine: this.engine,
			options: {
				background: 'transparent',
				wireframeBackground: 'transparent',
				wireframes: false,
				width: this.matterWidth,
				height: this.matterHeight,
				pixelRatio: 1,
				enabled: true
			}
		});
		Matter.Render.run(this.render);

	}


	bindEvents() {
		Main.on(Main.E.RAF, this.raf, this);
		Screen.on(Screen.E.RESIZE, this.resize, this);
		this.onBeforeUpdateHandler = this.onBeforeUpdate.bind(this);
		Matter.Events.on(this.engine, 'beforeUpdate', this.onBeforeUpdateHandler);
		super.bindEvents();
	}


	unbindEvents() {
		Main.off(Main.E.RAF, this.raf, this);
		Screen.off(Screen.E.RESIZE, this.resize, this);
		Matter.Events.off(this.engine, 'beforeUpdate', this.onBeforeUpdateHandler);
		super.unbindEvents();
	}

	resize(isMobileH) {

		if (isMobileH) {
			return;
		}

		this.maxForce = Screen.wW * 0.00000002;

		this.render.canvas.width = this.render.canvas.offsetWidth;
		this.render.canvas.height = this.render.canvas.offsetHeight;

		this.killRagdolls();
		this.createRagDolls();

	}


	raf() {
		Matter.Engine.update(this.engine, 1000 / 60);
	}

	onBeforeUpdate() {
		if (!this.ragdolls || !this.ragdolls.composites) {
			return;
		}
		// Continuous wind
		for (let i = 0; i < this.ragdolls.composites.length; i++) {
			// Same force for the entire shape
			const force = Matter.Vector.create(Matter.Common.random(-this.maxForce, this.maxForce), Matter.Common.random(-this.maxForce, this.maxForce));
			for (let j = 0; j < this.ragdolls.composites[i].bodies.length; j++) {
				const body = this.ragdolls.composites[i].bodies[j];
				Matter.Body.applyForce(body, {x: 0, y: 0}, force)
			}
		}
	}

	createRagDolls() {

		this.ragdolls = Matter.Composite.create();


		for (let i = 0; i < this.numRagdolls; i++) {
			const x = Math.random() * Screen.wW,
				y = Math.random() * Screen.wH,
				ragdoll = this.ragdoll(i / this.numRagdolls, x, y, Math_.clamp(Screen.wW / 1280, 0.3, 1));
			// const ragdoll = this.ragdoll(i / this.numRagdolls, Screen.wW * 0.5, Screen.wH * 0.5, Math_.clamp(Screen.wW / 1280, 0.3, 1));
			Matter.Composite.add(this.ragdolls, ragdoll);
			Matter.Composite.rotate(ragdoll, Math.PI * 2 * Math.random(), {x: x, y: y}, true);
			/*const maxForce = Screen.wW * 0.000000001,
				force = Matter.Vector.create(Matter.Common.random(-maxForce, maxForce), Matter.Common.random(-maxForce, maxForce));
			for (let j = 0; j < this.ragdolls.composites[i].bodies.length; j++) {
				const body = this.ragdolls.composites[i].bodies[j];
				Matter.Body.applyForce(body, {x: 0, y: 0}, force)
			}*/
		}

		Matter.Composite.add(this.world, [this.ragdolls]);
	}

	ragdoll(percent = 0, x = 0, y = 0, scale = 1) {

		// Matter shortcuts
		const Bodies = Matter.Bodies,
			Constraint = Matter.Constraint,
			Composite = Matter.Composite,
			Common = Matter.Common;

		// Current category	
		const category = Matter.Body.nextCategory();

		// The color
		const colorRG = 32 + ((percent) * (43 - 32)),
			colorB = 32 + ((percent) * (226 - 32)),
			color = 'rgb(' + colorRG + ',' + colorRG + ',' + colorB + ')';

		// Default options
		const options = {
			isStatic: false,
			render: {
				fillStyle: color
			}
		}

		// Sizes & dimensions
		const sizes = {
			head: {
				r: 20,
				x: 0,
				y: -7,
			},
			chest: {
				w: 55,
				h: 90,
				x: 0,
				y: 60,
			},
			arm: {
				w: 20,
				h: 60,
				x: 35,
				y: 65,
			},
			leg: {
				w: 20,
				h: 60,
				x: 15,
				y: 135,
			}
		}


		// Parts options
		const headOptions = Common.extend({
				label: 'head',
				collisionFilter: this.getCollisionFilter(category),
			}, options),
			chestOptions = Common.extend({
				label: 'chest',
				collisionFilter: this.getCollisionFilter(category),
				chamfer: {
					radius: [20 * scale, 20 * scale, 20 * scale, 20 * scale]
				},
			}, options),
			leftArmOptions = Common.extend({
				label: 'left-arm',
				collisionFilter: this.getCollisionFilter(category),
				chamfer: {
					radius: 10 * scale
				},
			}, options),
			leftLowerArmOptions = Common.extend({
				chamfer: {
					radius: 10 * scale
				},
			}, leftArmOptions),
			rightArmOptions = Common.extend({
				label: 'right-arm',
				collisionFilter: this.getCollisionFilter(category),
				chamfer: {
					radius: 10 * scale
				},
			}, options),
			rightLowerArmOptions = Common.extend({
				chamfer: {
					radius: 10 * scale
				},
			}, rightArmOptions),
			leftLegOptions = Common.extend({
				label: 'left-leg',
				collisionFilter: this.getCollisionFilter(category),
				chamfer: {
					radius: 10 * scale
				},
			}, options),
			leftLowerLegOptions = Common.extend({
				collisionFilter: this.getCollisionFilter(category),
			}, leftLegOptions),
			rightLegOptions = Common.extend({
				label: 'right-leg',
				collisionFilter: this.getCollisionFilter(category),
				chamfer: {
					radius: 10 * scale
				},
			}, options),
			rightLowerLegOptions = Common.extend({
				collisionFilter: this.getCollisionFilter(category),
			}, rightLegOptions);

		// The body parts
		const head = Bodies.circle(x + sizes.head.x * scale, y + sizes.head.y * scale, sizes.head.r * scale, headOptions),
			chest = Bodies.rectangle(x + sizes.chest.x * scale, y + sizes.chest.y * scale, sizes.chest.w * scale, sizes.chest.h * scale, chestOptions),
			rightUpperArm = Bodies.rectangle(x + sizes.arm.x * scale, y + sizes.arm.y * scale, sizes.arm.w * scale, sizes.arm.h * scale, rightArmOptions),
			rightLowerArm = Bodies.rectangle(x + sizes.arm.x * scale, y + ((sizes.arm.y + sizes.arm.h) * scale), sizes.arm.w * scale, sizes.arm.h * scale, rightLowerArmOptions),
			leftUpperArm = Bodies.rectangle(x - sizes.arm.x * scale, y + sizes.arm.y * scale, sizes.arm.w * scale, sizes.arm.h * scale, leftArmOptions),
			leftLowerArm = Bodies.rectangle(x - sizes.arm.x * scale, y + ((sizes.arm.y + sizes.arm.h) * scale), sizes.arm.w * scale, sizes.arm.h * scale, leftLowerArmOptions),
			leftUpperLeg = Bodies.rectangle(x + sizes.leg.x * scale, y + sizes.leg.y * scale, sizes.leg.w * scale, sizes.leg.h * scale, leftLegOptions),
			leftLowerLeg = Bodies.rectangle(x + sizes.leg.x * scale, y + ((sizes.leg.y + sizes.leg.h) * scale), sizes.leg.w * scale, sizes.leg.h * scale, leftLowerLegOptions),
			rightUpperLeg = Bodies.rectangle(x - sizes.leg.x * scale, y + sizes.leg.y * scale, sizes.leg.w * scale, sizes.leg.h * scale, rightLegOptions),
			rightLowerLeg = Bodies.rectangle(x - sizes.leg.x * scale, y + ((sizes.leg.y + sizes.leg.h) * scale), sizes.leg.w * scale, sizes.leg.h * scale, rightLowerLegOptions);

		// Constraints
		const debugConstraints = false,

			// HEAD
			headContraint = Constraint.create({
				bodyA: head,
				bodyB: chest,
				pointA: {
					x: 0,
					y: sizes.head.r * scale
				},
				pointB: {
					x: 0,
					y: -sizes.chest.h / 2 * scale
				},
				length: 0,
				stiffness: 0.6,
				render: {
					visible: debugConstraints
				}
			}),

			// EPAULES
			chestToRightUpperArm = Constraint.create({
				bodyA: chest,
				bodyB: rightUpperArm,
				pointA: {
					x: (sizes.chest.w / 2) * scale,
					y: (-sizes.chest.h / 3) * scale
				},
				pointB: {
					x: (-sizes.arm.w / 2) * scale,
					y: (-sizes.arm.h / 2) * scale
				},
				length: 0,
				stiffness: 1,
				render: {
					visible: debugConstraints
				}
			}),
			chestToLeftUpperArm = Constraint.create({
				bodyA: chest,
				bodyB: leftUpperArm,
				pointA: {
					x: (-sizes.chest.w / 2) * scale,
					y: (-sizes.chest.h / 3) * scale
				},
				pointB: {
					x: (sizes.arm.w / 2) * scale,
					y: (-sizes.arm.h / 2) * scale
				},
				length: 0,
				stiffness: 1,
				render: {
					visible: debugConstraints
				}
			}),

			// BASSIN
			chestToLeftUpperLeg = Constraint.create({
				bodyA: chest,
				bodyB: leftUpperLeg,
				pointA: {
					x: (sizes.leg.x) * scale,
					y: (sizes.chest.h / 2) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.leg.h / 2) * scale
				},
				stiffness: 1,
				render: {
					visible: debugConstraints
				}
			}),
			chestToRightUpperLeg = Constraint.create({
				bodyA: chest,
				bodyB: rightUpperLeg,
				pointA: {
					x: (-sizes.leg.x) * scale,
					y: (sizes.chest.h / 2) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.leg.h / 2) * scale
				},
				stiffness: 1,
				render: {
					visible: debugConstraints
				}
			}),

			// COUDE
			upperToLowerRightArm = Constraint.create({
				bodyA: rightUpperArm,
				bodyB: rightLowerArm,
				pointA: {
					x: 0,
					y: (sizes.arm.h / 2.5) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.arm.h / 2.5) * scale
				},
				length: 0,
				stiffness: 0.9,
				render: {
					visible: debugConstraints
				}
			}),
			upperToLowerLeftArm = Constraint.create({
				bodyA: leftUpperArm,
				bodyB: leftLowerArm,
				pointA: {
					x: 0,
					y: (sizes.arm.h / 2.5) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.arm.h / 2.5) * scale
				},
				length: 0,
				stiffness: 0.9,
				render: {
					visible: debugConstraints
				}
			}),

			// GENOUX
			upperToLowerLeftLeg = Constraint.create({
				bodyA: leftUpperLeg,
				bodyB: leftLowerLeg,
				pointA: {
					x: 0,
					y: (sizes.leg.h / 2.5) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.leg.h / 2.5) * scale
				},
				length: 0,
				stiffness: 0.9,
				render: {
					visible: debugConstraints
				}
			}),
			upperToLowerRightLeg = Constraint.create({
				bodyA: rightUpperLeg,
				bodyB: rightLowerLeg,
				pointA: {
					x: 0,
					y: (sizes.leg.h / 2.5) * scale
				},
				pointB: {
					x: 0,
					y: (-sizes.leg.h / 2.5) * scale
				},
				length: 0,
				stiffness: 0.9,
				render: {
					visible: debugConstraints
				}
			}),
			legToLeg = Constraint.create({
				bodyA: leftLowerLeg,
				bodyB: rightLowerLeg,
				stiffness: 0.01,
				render: {
					visible: debugConstraints
				}
			});

		// Create the entire ragdoll
		const ragdoll = Composite.create({
			bodies: [
				chest, head, leftLowerArm, leftUpperArm,
				rightLowerArm, rightUpperArm, leftLowerLeg,
				rightLowerLeg, leftUpperLeg, rightUpperLeg
			],
			constraints: [
				upperToLowerLeftArm, upperToLowerRightArm, chestToLeftUpperArm,
				chestToRightUpperArm, headContraint, upperToLowerLeftLeg,
				upperToLowerRightLeg, chestToLeftUpperLeg, chestToRightUpperLeg,
				legToLeg
			]
		});

		// The ragdoll wraps the screen
		ragdoll.plugin.wrap = {
			min: {
				x: 0,
				y: 0
			},
			max: {
				x: Screen.wW,
				y: Screen.wH
			}
		}

		return ragdoll;
	}

	getCollisionFilter(category) {
		return {
			group: Matter.Body.nextGroup(true),
			mask: category,
			category: category
		};
	}

	killRagdolls() {
		if (this.ragdolls && this.ragdolls.composites) {
			Matter.Composite.remove(this.world, this.ragdolls, true);
		}
	}

	destroy() {
		this.killRagdolls();
		Matter.World.clear(this.engine.world);
		Matter.Engine.clear(this.engine);
		super.destroy();
	}

}
